import {
	MimaButton,
	MimaDateInput,
	MimaDropdown,
	MimaInput,
	MimaText,
	MimaTextArea,
	Modal,
	ReceiptCheckBox as RCB,
	PageLoader,
} from '../../components';
import styles from '../../assets/styles/BulkSms/BulkSms.module.scss';
import { customerStore } from '../../stores';
import { Formik } from 'formik';
import React from 'react';
import OtpInput from 'react-otp-input';
import moment from 'moment';

const ScheduleMessage = ({
	closeModal,
	validationSchema,
	onSubmit,
	loading,
	goBack,
	showOtp,
	otp,
	setOtp,
	onSubmitOtp,
	btnClicked,
	selectedMessage
}) => {
	return (
		<Modal closeModal={closeModal} goBack={goBack}>
			<MimaText variant="subtitleBold" align="center" width={38} mb={3}>
				Schedule Message
			</MimaText>

			{showOtp ? (
				<Formik
					initialValues={{
						otp: '',
					}}
					onSubmit={onSubmitOtp}>
					{({ handleChange, handleBlur, values, errors, touched }) => (
						<form onSubmit={onSubmit}>
							{loading ? (
								<PageLoader
									title="Sending Your Message(s)...."
									loading={loading}
								/>
							) : (
								<div className={styles.centerContent}>
									<MimaText align="center" mb={2} variant="bodyBold" color="var(--color-primary)">
										Enter your pin to send message
									</MimaText>

									<div className={styles.pin__group}>
										<MimaText ml={2} mb={0.5}>Enter Pin</MimaText>
										<div className={styles.otp__group}>
											<OtpInput
												value={otp}
												onChange={otp => {
													setOtp(otp);
													if (otp >= 1000) {
														onSubmitOtp(otp);
													}
												}}
												numInputs={4}
												isInputSecure={true}
												inputStyle={{
													fontSize: '2.4rem',
													fontFamily: 'inherit',
													width: '6rem',
													height: '6rem',
													margin: '.4rem',
													borderTop: '0px',
													border: '1px solid #4A4A68',
													borderRadius: '1rem',
													display: 'block',
													outline: 'none',
													textAlign: 'center',
													marginRight: '2rem',
												}}
												isInputNum
											/>
										</div>
									</div>
								</div>
							)}
						</form>
					)}
				</Formik>) : (
				<Formik
					initialValues={{
						scheduleTime: btnClicked === "scheduleMessageEdit" ? "" : "10mins",
						selectedDate: "",
						selectedTime: "",
						otp: '',
					}}
					validationSchema={validationSchema()}
					onSubmit={onSubmit}
				>
					{({
						handleChange,
						handleBlur,
						handleSubmit,
						setFieldValue,
						values,
						errors,
						touched,
					}) => (
						<>
							{loading ? (
								<PageLoader
									title="Changing your Schedule"
									loading={loading}
								/>
							) : (
								<div className={styles.schedule}>

									{btnClicked === "scheduleMessageEdit" ? (
										<MimaText variant="bodyBold" labelTitle="Previously Scheduled for" mb={2}>
											{moment(selectedMessage.scheduledTime).format("DD/MM/YY HH:mm A")}
										</MimaText>) : ""}
									<RCB
										title="10 mins"
										onChange={() => {
											setFieldValue('scheduleTime', "10mins");
											setFieldValue('selectedDate', "");
											setFieldValue('selectedTime', "");
										}}
										checked={values.scheduleTime === "10mins"}
										value="10mins"
										name="scheduleTime"
									/>
									<RCB
										title="1 hour"
										onChange={() => {
											setFieldValue('scheduleTime', "1hr");
											setFieldValue('selectedDate', "");
											setFieldValue('selectedTime', "");
										}}
										checked={values.scheduleTime === "1hr"}
										value="1hr"
										name="scheduleTime"
									/>
									<RCB
										title="10am Tomorrow"
										onChange={() => {
											setFieldValue('scheduleTime', "10amNextDay");
											setFieldValue('selectedDate', "");
											setFieldValue('selectedTime', "");
										}}
										checked={values.scheduleTime === "10amNextDay"}
										value="10amNextDay"
										name="scheduleTime"
									/>
									<RCB
										title="Next week on Monday at 10am"
										onChange={() => {
											setFieldValue('scheduleTime', "10amNextMonday");
											setFieldValue('selectedDate', "");
											setFieldValue('selectedTime', "");
										}}
										checked={values.scheduleTime === "10amNextMonday"}
										value="10amNextMonday"
										name="scheduleTime"
									/>
									<RCB
										title="Custom Date"
										onChange={() => {
											setFieldValue('scheduleTime', "customDate");
											setFieldValue('selectedDate', "");
											setFieldValue('selectedTime', "");
										}}
										checked={values.scheduleTime === "customDate"}
										value="customDate"
										name="scheduleTime"
									/>
									{(touched.scheduleTime && errors.scheduleTime) ? (
										<MimaText width={38} color="var(--color-error)" mt={2}>
											{errors.scheduleTime}
										</MimaText>) : ""}
									{values.scheduleTime === "customDate" && (
										<div className='modal__beside'>
											<MimaDateInput
												labelTitle="Select Date"
												width={18}
												name="selectedDate"
												value={values.selectedDate}
												onChange={text => {
													setFieldValue('selectedDate', text);
												}}
												onBlur={handleBlur}
												touched={touched.selectedDate}
												error={errors.selectedDate}
											/>
											<MimaInput
												labelTitle="Select Time"
												width={18}
												type="time"
												name="selectedTime"
												mb={1}
												value={values.selectedTime}
												onChange={handleChange}
												onBlur={handleBlur}
												touched={touched.selectedTime}
												error={errors.selectedTime}
											/>
										</div>
									)}
									{/* <MimaDropdown labelTitle="Select Time Zone" /> */}
									<MimaButton title={btnClicked === "scheduleMessageEdit" ? "Save New Schedule" : "Schedule and Send"} onClick={handleSubmit} mt={2} />



								</div>)}
						</>




					)}
				</Formik>
			)}

		</Modal>

	);
};

export default ScheduleMessage;
